import React from 'react';
import { Booking, Profile, UtilityService } from 'us-web-services';
import checked from './checked.svg';
import checkedGrey from './checked-grey.svg';
import progress from './progress.svg';
import pendingPayment from './pending-payment.svg';
import rejectGrey from './reject-grey.svg';

export type Props = {
  booking: Booking;
  profile?: Profile;
  classes?: string;
  getDateString(booking: Booking): string;
  linkComponent?: JSX.Element;
};

const PHOTO_WIDTH = 50;
const PHOTO_HEIGHT = 50;

export const DashboardBookingCard = ({ booking, profile, classes, getDateString, linkComponent }: Props): JSX.Element => {
  const firstName = profile?.firstName;
  const pictureUrl = profile?.pictureUrl;

  const getIcon = (): string => {
    switch (booking?.status?.webIcon) {
      case 'checked':
        return checked;
      case 'checked-grey':
        return checkedGrey;
      case 'progress':
        return progress;
      case 'pending-payment':
        return pendingPayment;
      case 'reject-grey':
        return rejectGrey;
      default:
        return progress;
    }
  }

  return (
    <div className={`border-b-2 ${classes}`}>
      <div className='flex relative'>
        <div className='w-14'>
          <img src={pictureUrl} className='rounded-full float-left mr-2'
               width={PHOTO_WIDTH} height={PHOTO_HEIGHT}
               alt={`${firstName} profile`} />
          <img
            alt={`Booking ${booking?.id ? booking.id : ''} status`}
            src={getIcon()}
            className='float-left h-4 absolute'
          />
        </div>
        <div className='flex-1'>
          <div className='font-bold text-sm'>{UtilityService.sentenceCase(booking?.status?.label)} with {firstName}</div>
          <div className='text-sm'>{getDateString(booking)}</div>
          <div>
            {linkComponent}
          </div>
        </div>
      </div>
    </div>
  );
};
